import axios from 'axios';

import { type PaymentMethod, type ShippingMethodEnum } from '../../shared/paymentTypes';

async function checkPaymentMethodAvailability(
    paymentMethod: PaymentMethod,
    totalAmount: number,
    shippingMethod: ShippingMethodEnum,
): Promise<{ available: boolean }> {
    const response = await axios.get<{ available: boolean }>(
        `/api/payment-methods/${paymentMethod}/availability?totalAmount=${totalAmount}&shippingMethod=${shippingMethod}`,
    );

    return response.data;
}

export { checkPaymentMethodAvailability };
